module.exports = __webpack_public_path__ + "img/solutions_banner.4ca9ae1c.png";